import React from 'react';

import { MdFileDownload } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { useOrgProfile } from '@modules/permissionManager/duck/hooks';
import {
  Button,
  Card,
  DetailItem,
  ProgramLogo,
  S,
  UnitGenderPill,
} from '@modules/shared/components';

import styles from './UnitInfo.less';

export const UnitInfo = () => {
  const { data, isFetching: loading } = useOrgProfile();

  const {
    organizationFullName,
    councilName,
    districtName,
    charter,
    acceptGender,
    typeId,
    executiveOfficer,
  } = data || {};
  const { communityOrganizationName = '' } = charter || {};

  const handleDownloadPdf = () => {
    window.open(
      'https://filestore.scouting.org/filestore/pdf/Permissions%20Manager%20Helps.pdf',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <Card margin shadow>
      <S size="4" hr bold colored>
        <FormattedMessage id="advancement.UnitInfo.heading" />
      </S>
      <Card noPadding loading={loading} className={styles.detailCard}>
        <div className={styles.detailsContainer}>
          <div>
            <div className={styles.titleContainer}>
              <div className={styles.titleRow}>
                <ProgramLogo className={styles.logo} programId={typeId} />
                <S size="4" bold className={styles.packName}>
                  {organizationFullName}
                </S>
                <UnitGenderPill gender={acceptGender} />
              </div>
            </div>

            <DetailItem
              className={styles.detailItem}
              label={<FormattedMessage id="advancement.UnitInfo.council" />}
            >
              {councilName}
            </DetailItem>
            <DetailItem
              className={styles.detailItem}
              label={<FormattedMessage id="advancement.UnitInfo.district" />}
            >
              {districtName}
            </DetailItem>
            <DetailItem
              className={styles.detailItem}
              label={
                <FormattedMessage id="advancement.UnitInfo.charteredOrg" />
              }
            >
              {communityOrganizationName}
            </DetailItem>
            <Button
              type="primary"
              uppercase={false}
              fitText
              size="small"
              onClick={handleDownloadPdf}
              className={styles.downloadButton}
              shape="round"
            >
              <MdFileDownload />
              <FormattedMessage id="permissionManager.unitInfo.downloadPdf" />
            </Button>
          </div>
          {executiveOfficer && (
            <Card className={styles.execOfficerCard}>
              <S size="4" bold colored>
                Executive officer
              </S>
              <div>{executiveOfficer.personFullName}</div>
            </Card>
          )}
        </div>
      </Card>
    </Card>
  );
};
